export * from './src/dynamic-html/index';
export * from './src/dynamic-component/index';



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/~/ng-dynamic/index.js
// module id = ../../../../ng-dynamic/index.js
// module chunks = 3